

define(['jquery', 'squid', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/address/index', 'components/xo-address-components/src/add-address/directive', 'components/xo-form-components/src/select-shipping-country/directive', 'components/xo-tray-height/dist/directive', 'components/xo-ui-components/src/dropdown/directive', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-ui-components/src/message/directive', 'components/xo-form-components/src/zipcode/directive', 'components/xo-ui-components/src/accessibility/directive'], function ($, squid, template) {

    return squid.module('xo-select-shipping.xo-shipping-address.directive', ['squid', 'xomodel.address', 'xomodel.checkout', 'xo-add-address.directive', 'xo-select-shipping-country.directive', 'xo-tray-height.directive', 'xo-error-tooltip.directive', 'xo-dropdown.directive', 'xo-message.directive', 'xo-zipcode.directive', 'xo-accessibility.directive']).directive('xoShippingAddress', function () {

        return {
            template: template,

            scope: {
                auth: '=',
                token: '=',
                doneFn: '=',
                sidebar: '=',
                update: '='
            },

            controller: function controller($scope, $populate, $element, $timeout, $ShippingAddressModel, $CheckoutSessionModel, $logger, $PrefillAddressModel, $CheckoutAppDataModel, $state, $config, $locale, $feature, $renderContent) {

                if (!$scope.sidebar) {
                    $scope.pageTitle = $renderContent('addShipping.addAddress');
                }

                $scope.buttonLabel = function () {
                    if (!$scope.sidebar || $scope.address.country === 'BR' && !$scope.prefilled) {
                        return $renderContent('common.continueLabel');
                    } else {
                        return $renderContent('common.save');
                    }
                };

                $scope.address = {
                    country: $locale.getCountryCodeISO()
                };
                $scope.isShipping = true;
                $scope.normalize = function () {
                    return $feature('shippingAddressNormalization') && $scope.address.country === $locale.country // Should be domestic address
                    && !$scope.normalized;
                };

                $scope.showshipping = true;
                $scope.country = $locale.country;
                $scope.recipient = {
                    first_name: '',
                    last_name: ''
                };

                var $el = $($element);

                function focusFirstError() {
                    $el.find('form').find('.backendError, .ng-invalid').first().focus();
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
                }).then(function () {
                    var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                    var contingencyPrefilledAddress;

                    if ($feature('supportBlockNonDomesticShipping', false, merchantCountry)) {

                        $scope.disableChangeShippingCountry = $scope.checkoutAppData.get('flags.block_non_domestic_shipping', false);

                        if ($scope.disableChangeShippingCountry) {

                            $scope.address.country = merchantCountry;

                            contingencyPrefilledAddress = $scope.checkoutSession.get('errorData.resolution.data', null);
                            if (!$scope.sidebar && contingencyPrefilledAddress) {
                                angular.extend($scope.address, {
                                    line1: contingencyPrefilledAddress.line1,
                                    line2: contingencyPrefilledAddress.line2,
                                    city: contingencyPrefilledAddress.city,
                                    state: contingencyPrefilledAddress.state,
                                    postal_code: contingencyPrefilledAddress.postal_code
                                });
                            }

                            $logger.info('member_block_non_domestic_shipping', {
                                block_non_domestic_shipping: $scope.disableChangeShippingCountry,
                                sidebar: $scope.sidebar
                            });

                            var countryName = $renderContent('shippingCountry.' + merchantCountry);
                            var infoMessage = $renderContent('largeScreenPayment.blockNonDomesticShippingAlert', {
                                shippingCountry: countryName
                            });
                            $scope.message = {
                                msgs: [infoMessage],
                                type: 'warning'
                            };
                        }
                    }

                    $scope.prefill = function () {
                        $scope.prefillAddress = new $PrefillAddressModel({
                            id: $scope.token,
                            address: {
                                country: $locale.country,
                                postal_code: $scope.address.postal_code
                            }
                        });

                        $scope.prefillAddress.save({
                            data: $scope.prefillAddress,

                            success: function success(result) {
                                if (result) {
                                    $scope.address = result;
                                }
                                $scope.prefilled = true;
                                $scope.address.first_name = $scope.recipient.first_name;
                                $scope.address.last_name = $scope.recipient.last_name;

                                $timeout(function () {
                                    var value = $scope.address.state;

                                    var $option = $el.find('[value="' + value + '"]');
                                    $option.prop('selected', 'selected');
                                    $option.trigger('change');

                                    value = $option.attr('label');
                                    focusFirstError();
                                }, 1000);
                            }
                        });
                    };

                    if ($scope.update) {
                        if ($scope.checkoutSession.shipping.name) {
                            var name = $scope.checkoutSession.shipping.name.trim();
                            var index = name.indexOf(' ');
                            $scope.recipient.first_name = name.substr(0, index);
                            $scope.recipient.last_name = name.substr(index + 1);
                        }
                        $scope.address.postal_code = $scope.checkoutSession.get('shipping.postal_code', '');
                        $scope.prefill();
                    }

                    function handleValidation(res) {
                        if (res && res.fields && res.fields.length) {
                            res.fields.forEach(function (field) {
                                if (field.field) {
                                    var $field = $($el.find('[ng-model="address.' + field.field + '"]'));
                                    if ($field.length === 0 && field.field === 'zip') {
                                        $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                                    }
                                    $field.addClass('backendError');
                                    $field.attr('aria-invalid', true);
                                }
                            });
                            focusFirstError();
                        }
                    }

                    $scope.cancelFn = function () {
                        $state.go('checkout.review.sidebar.shipping');
                    };

                    $scope.onSubmit = function () {
                        if ($scope.address.country === 'BR' && $scope.address.country === $locale.country && !$scope.prefilled) {
                            return $scope.prefill();
                        }

                        if ($scope.normalize()) {
                            $scope.showshipping = false;
                            $state.go('.addressNormalization');
                        } else {
                            $scope.submitAddress();
                        }
                    };

                    $scope.removeValidation = function () {
                        $el.find('form').removeClass('validated');
                    };

                    function prefilledAddressUnchanged(prefilledAddress, addressToSubmit) {

                        function lowercaseEquals(str1, str2) {
                            return angular.lowercase(str1) === angular.lowercase(str2);
                        }

                        return lowercaseEquals(prefilledAddress.recipient_name, addressToSubmit.recipient_name) && lowercaseEquals(prefilledAddress.line1, addressToSubmit.line1) && lowercaseEquals(prefilledAddress.line2, addressToSubmit.line2) && lowercaseEquals(prefilledAddress.city, addressToSubmit.city) && lowercaseEquals(prefilledAddress.state, addressToSubmit.state) && lowercaseEquals(prefilledAddress.postal_code, addressToSubmit.postal_code) && lowercaseEquals(prefilledAddress.country_code, addressToSubmit.country);
                    }

                    $scope.submitAddress = function () {

                        if ($scope.address.preferred_address) {
                            $logger.info('addAddrPreferred.selected', {});
                        }

                        var country = $scope.address.country;

                        // keep this for compatability
                        var recipient_name = $scope.address.first_name + ' ' + $scope.address.last_name;
                        if ($feature('nameFormat', country, country) === 'LastFirst') {
                            recipient_name = $scope.address.last_name + ' ' + $scope.address.first_name;
                        }

                        var data = {
                            recipient_name: recipient_name,
                            first_name: $scope.address.first_name,
                            last_name: $scope.address.last_name,
                            line1: $scope.address.line1,
                            line2: $scope.address.line2,
                            city: $scope.address.city,
                            state: $scope.address.state,
                            postal_code: $scope.address.postal_code,
                            country: country,
                            normalization_status: $scope.address.normalization_status,
                            preferred_address: $scope.address.preferred_address,
                            default_address: true
                        };

                        if (contingencyPrefilledAddress && prefilledAddressUnchanged(contingencyPrefilledAddress, data)) {
                            data.address_id = contingencyPrefilledAddress.id;
                        }
                        // Update is used for the address normalization flow.
                        data.address_id = data.address_id ? data.address_id : $scope.checkoutSession.get('shipping.id');
                        if ($scope.update && data.address_id) {
                            updateAddress(data);
                        } else {
                            addAddress(data);
                        }
                    };

                    function updateAddress(payload) {
                        $scope.checkoutSession.shipping.action('update', {
                            data: payload,

                            resultModel: $scope.checkoutSession,

                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['smallToolTip.addressAdded']
                                };

                                $scope.doneFn();
                            },

                            validation: function validation(res) {
                                handleValidation(res);
                            }
                        });
                    }

                    function addAddress(payload) {
                        // make sure this param is not passed as behavior from symphony is erratic. 
                        delete payload.address_id;

                        $scope.shippingAddress = $ShippingAddressModel.create($scope.token, payload);

                        $scope.shippingAddress.save({
                            data: payload,

                            resultModel: $scope.checkoutSession,

                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['smallToolTip.addressAdded']
                                };
                                $scope.doneFn();
                            },

                            validation: function validation(res) {
                                handleValidation(res);
                            }
                        });
                    }

                    $scope.uponNormalization = function (normalizedAddress, isBack) {
                        if (isBack) {
                            $scope.normalized = false;
                            $scope.showshipping = true;
                            $state.go('^');
                        } else {
                            $scope.address = normalizedAddress;
                            $scope.normalized = true;
                            $scope.address.first_name = $scope.recipient.first_name;
                            $scope.address.last_name = $scope.recipient.last_name;
                            $scope.submitAddress();
                        }
                    };
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/select-shipping/shipping-address/directive.js
// module id = ./components/xo-member-components/src/select-shipping/shipping-address/directive.js
// module chunks = 1